import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CompleteOrderDialogComponent } from './complete-order-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImageGalleryModule } from '../../../_shared/presentational-components/image-gallery/image-gallery.module';

@NgModule({
  declarations: [
    CompleteOrderDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    FlexLayoutModule,
    ImageGalleryModule
  ]
})
export class CompleteOrderDialogModule {
}
